var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-footer', {
    style: {
      'box-shadow': _vm.boxShadow
    },
    attrs: {
      "padless": ""
    }
  }, [_c('v-card', {
    style: {
      'background-color': _vm.color
    },
    attrs: {
      "flat": "",
      "tile": "",
      "width": "100%"
    }
  }, [_c('v-container', {
    staticClass: "footerContainer",
    style: {
      color: _vm.fontColor
    }
  }, [_c('v-container', {
    staticClass: "flex-column"
  }, [_c('v-container', {
    staticClass: "marginContainer"
  }, [_c('v-row', [_c('h3', {
    staticClass: "text-truncate"
  }, [_vm._v(_vm._s(_vm.$t("partner.PartnerFooter.contact")))])]), _c('v-row', [_c('span', [_vm._v(_vm._s(_vm.partnerProp.companyName))])]), _vm.address ? _c('v-row', [_c('span', [_vm._v(_vm._s(_vm.address.street))])]) : _vm._e(), _vm.address ? _c('v-row', [_c('span', [_vm._v(" " + _vm._s(_vm.address.zip) + " " + _vm._s(_vm.address.city) + " ")])]) : _vm._e(), _vm.settings ? _c('v-row', [_c('span', [_vm._v(_vm._s(_vm.partnerProp.settings.contact.email))])]) : _vm._e(), _vm.settings ? _c('v-row', [_c('span', [_vm._v(_vm._s(_vm.partnerProp.settings.contact.phone))])]) : _vm._e(), _vm.isWebsitePresent ? _c('v-row', [_c('a', {
    style: "color:".concat(_vm.fontColor, ";"),
    attrs: {
      "href": "".concat(_vm.partnerProp.settings.websites[0].link)
    }
  }, [_vm._v(" " + _vm._s(_vm.partnerProp.settings.websites[0].text) + " ")])]) : _vm._e()], 1)], 1), _vm.isOpeningTimeInformationPresent ? [_c('v-container', {
    staticClass: "flex-column"
  }, [_c('v-container', {
    staticClass: "marginContainer"
  }, [_c('v-row', [_c('h3', [_vm._v(_vm._s(_vm.$t("partner.PartnerFooter.openingHours")))])]), _c('v-row', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.monday")) + " " + _vm._s(_vm.partnerProp.settings.openingHours.monday || _vm.$t("partner.PartnerFooter.openingHoursDefault")) + " ")])]), _c('v-row', [_c('span', [_vm._v(_vm._s(_vm.$t("partner.PartnerFooter.tuesday")) + " " + _vm._s(_vm.partnerProp.settings.openingHours.tuesday || _vm.$t("partner.PartnerFooter.openingHoursDefault")) + " ")])]), _c('v-row', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.wednesday")) + " " + _vm._s(_vm.partnerProp.settings.openingHours.wednesday || _vm.$t("partner.PartnerFooter.openingHoursDefault")) + " ")])]), _c('v-row', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.thursday")) + " " + _vm._s(_vm.partnerProp.settings.openingHours.thursday || _vm.$t("partner.PartnerFooter.openingHoursDefault")) + " ")])]), _c('v-row', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.friday")) + " " + _vm._s(_vm.partnerProp.settings.openingHours.friday || _vm.$t("partner.PartnerFooter.openingHoursDefault")) + " ")])]), _c('v-row', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.saturday")) + " " + _vm._s(_vm.partnerProp.settings.openingHours.saturday || _vm.$t("partner.PartnerFooter.openingHoursDefault")) + " ")])]), _c('v-row', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.sunday")) + " " + _vm._s(_vm.partnerProp.settings.openingHours.sunday || _vm.$t("partner.PartnerFooter.openingHoursDefault")) + " ")])])], 1)], 1)] : _vm._e(), _c('v-container', [_c('v-container', {
    staticClass: "marginContainer"
  }, [_c('v-row', [_c('h3', [_vm._v(_vm._s(_vm.$t("partner.PartnerFooter.hostedBy")))])]), _c('v-row', [_c('a', {
    style: "padding-bottom:10px; color:".concat(_vm.fontColor, ";"),
    attrs: {
      "href": "https://www.mmmint.ai"
    }
  }, [_vm._v(" www.mmmint.ai ")])]), _c('v-row', [_c('a', {
    style: "padding-bottom:10px; color:".concat(_vm.fontColor, ";"),
    attrs: {
      "href": "https://www.mmmint.ai/datenschutz"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.privacy")) + " ")])]), _c('v-row', [_c('a', {
    style: "padding-bottom:10px; color:".concat(_vm.fontColor, ";"),
    attrs: {
      "href": "https://www.mmmint.ai/impressum"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerFooter.imprint")) + " ")])])], 1)], 1)], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }